var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-down"},[(_vm.hasSlot)?[_vm._t("default",null,{"days":_vm.timeData.days,"hours":_vm.timeData.hours,"minutes":_vm.timeData.minutes,"seconds":_vm.timeData.seconds,"milliseconds":_vm.timeData.milliseconds})]:_vm._l((_vm.formattedTime),function(item,index){return _c('span',{key:index},[_vm._v(_vm._s(`${item}`))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }